import initialState from "./initialState";

const mutations = {
  setKPIPackages: (state, packages) => (state.packages = packages),
  setKPIInsights: (state, insights) => (state.insights = insights),
  setKPITags: (state, tags) => (state.tags = tags),
  resetModule: (state) => (Object.assign(state, initialState()))
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/kpis/mutations.js